import React, { useMemo } from 'react'
import { dialogTypes } from '@/dialogs'
import context from '@/context'
import {
  createLookupFilterCell,
  LookupCell,
  Column,
  LookupNameColumn,
  BooleanColumn
} from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { individualPermissionTypes } from '@/enums/individualPermissionTypes'
import { IndividualPermissionProvider } from '@/components/changeRequests/individualPermissionProvider'

const AddressesBranch = React.memo(function AddressesBranch ({ dataSource }) {
  return <AddressesPermissions dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.Branches} />
})

const AddressesInstitution = React.memo(function AddressesInstitution ({ dataSource }) {
  return <AddressesPermissions dataSource={dataSource} institutionPermission={institutionPermissionTypes.enum.Addresses} />
})

const AddressesIndividual = React.memo(function AddressesIndividual ({ dataSource }) {
  return <IndividualPermissionProvider individualPermission={individualPermissionTypes.enum.IndividualAddresses}>
    <Addresses dataSource={dataSource} />
  </IndividualPermissionProvider>
})

const AddressesPermissions = React.memo(function AddressesPermissions ({ dataSource, institutionPermission }) {
  return <PermissionSectionProvider institutionPermission={institutionPermission}>
    <Addresses dataSource={dataSource} />
  </PermissionSectionProvider>
})

const Addresses = React.memo(function Addresses ({ dataSource }) {
  const { localize, locale } = useLocalization()
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.address }), [])
  return (
    <PropertyRenderer name='addresses' inputType='grid' dataSource={dataSource}
      addButtonLabel='Persons.AddAddress' detailDialog={detailDialog}>
      <Column field='addressType' title={localize('Persons.AddressType')} cell={LookupCell} width='120px'
        filterCell={createLookupFilterCell(context.cache.getAddressTypes)} />
      {BooleanColumn({ field: 'primary', title: localize('Persons.PrimaryAddress'), localize, width: '70px' })}
      {BooleanColumn({ field: 'previous', title: localize('Persons.PreviousAddress'), localize, width: '70px' })}
      <Column field='street' title={localize('Persons.AddressStreet')} />
      <Column field='latinStreet' title={localize('Persons.AddressLatinStreet')} />
      <Column field='city' title={localize('Persons.AddressCity')} width='100px' />
      <Column field='latinCity' title={localize('Persons.AddressLatinCity')} width='100px' />
      <Column field='zipCode' title={localize('Persons.AddressZipCode')} width='70px' />
      {LookupNameColumn({ locale, field: 'country', title: localize('Persons.Country'), editable: false, width: '150px' })}
    </PropertyRenderer>
  )
})

export { AddressesInstitution, AddressesIndividual, AddressesBranch }



// WEBPACK FOOTER //
// ./src/components/demographics/addresses.js